import hotkeyBindings from './hotkeyBindings';
export { hotkeyBindings };

const DefaultConfig = {
	hotkeyBindings,
};

export default DefaultConfig;
